import { AiFeedbackReasonTypes, AiFeedbackTypes } from '@lumapps/ai/types';
import { LumappsTrackingEventContext } from '@lumapps/analytics-tracking/types';
import { SearchFeedbackTypes } from '@lumapps/search-page/type';
import { SearchType } from '@lumapps/search/types';

export enum TargetType {
    ASK_REACTION = 'ask_reaction',
    SEARCH_REACTION = 'search_reaction',
    SEARCH_REACTION_IN_SPACE = 'search_reaction_in_space',
}

/**
 **************** *
 * Users feedback *
 ******************
 */

/** Fields common to all user feedback */
type CommonLumappsUserFeedback = {
    traceId: string;
    comment?: string;
};

/** Data to send with analytics to describe what results was sent at the moment of the feedback.  */
export type UserFeedbackSearchResultsDetails = { title: string; url: string };

// Ask
export type LumappsTrackingAskReaction = CommonLumappsUserFeedback & {
    type: TargetType.ASK_REACTION;
    reactionType: AiFeedbackTypes;
    feedbackReason?: AiFeedbackReasonTypes;
    sources?: UserFeedbackSearchResultsDetails[];
};

// Search
type LumappsTrackingSearchReactionBase = CommonLumappsUserFeedback & {
    reactionType: SearchFeedbackTypes;
    searchType: SearchType;
    results?: UserFeedbackSearchResultsDetails[];
};

export type LumappsTrackingSearchReaction = LumappsTrackingSearchReactionBase & {
    type: TargetType.SEARCH_REACTION;
};

export type LumappsTrackingSearchReactionInSpace = LumappsTrackingSearchReactionBase & {
    type: TargetType.SEARCH_REACTION_IN_SPACE;
};

// General types
export type LumappsUserFeedbackActionType =
    | LumappsTrackingSearchReaction
    | LumappsTrackingSearchReactionInSpace
    | LumappsTrackingAskReaction;

export interface LumappsUserFeedbackEvent {
    action: LumappsUserFeedbackActionType;
    sessionId: string;
    performedAt: string;
    context: LumappsTrackingEventContext;
}

export interface LumappsUserFeedbackEventPayload {
    action: LumappsUserFeedbackActionType;
}
